import { Component, OnInit, Output, EventEmitter, Input, TemplateRef, ViewChild, ElementRef, ChangeDetectorRef, Inject } from '@angular/core';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { ContactsVm, FilteredContactVm } from 'src/app/viewModels/core/contacts-vm';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ContactsService } from 'src/app/applicationModules/company/services/contacts.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { FormsService } from '../../services/forms.service';

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string,
}

@Component({
  selector: 'associate-contact-role-form',
  templateUrl: './associate-contact-role.component.html',
  styleUrls: ['./associate-contact-role.component.scss']
})
export class AssociateContactRoleFormComponent implements OnInit {
@Input() datalist:any=[]; 
@Input() companyID:number; 
@Input() formFolderID:number; 
@Input() typeId:number; 
showdetail:boolean = true;
addnewContact:boolean = false;
showAddContact:boolean = false;
addnewSharedContact:boolean = false;
isSharedAccessRolePopup:boolean=false;
Module:string;
filteredroles: Observable<string[]>;
value = '';
  NormalContacts: any=[];  
  //NormalCore :any=[];
  SharedContacts: any=[];
  SharedRoleList : any=[];
  stateCtrlValue: string="";
  @Output() showContactDetail = new EventEmitter<boolean>();
currentUser: any;
databaseId: string;
organizationId: string;
responseHolder: any;
contactsList: any=[];
isShare:boolean=false;
showAddButton = false;
spinner:boolean=false;
showContactRoleAddButton = false;
searchName:string='';
roleCtrl = new FormControl();
allTransRoles: any = [{name:'Buyer'},{name:'Seller'},{name:'Agent'}];
  selectedRoles: any=[];
  @ViewChild('roleInput') roleInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  selectable = true;
  removable = true;
  isRolePopup: boolean=false;
  Roles: any=[]; 
  transRoleList: any=[];
  sharedAccessRoleList: any=[];
  currentRoleContact: any;
  showDetail: boolean = false;
  TransactionId:number;
  peoples :any=[];  
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  mainModuleName:string="";
  selectedsharedAccessRole : any=[];
  action: any;
  actionTypeArray: string[];
  OfficeIDList: any=[];
  myOfficeID: any;
  ContactName:string="";
  sharedList :any=[]=[];

constructor(@Inject(MAT_DIALOG_DATA) public data: any,private formsService: FormsService, private statusConst: StatusConstant, private loaderService: LoaderService,
  private contactsService: ContactsService, private toastr: ToastrService,private filteredContactVm:FilteredContactVm,
  private contactsVm: ContactsVm, private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
  private dialog: MatDialog, private cdr: ChangeDetectorRef, private _dataSharingService: DataSharingService,
  public dialogRef: MatDialogRef<AssociateContactRoleFormComponent>) {

  const encryptedtoken = sessionStorage.getItem('userToken');
  this.databaseId = sessionStorage.getItem('databaseId');
  this.organizationId = sessionStorage.getItem('organizationID');
  const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
  this.currentUser = jwt_decode(token);
  var offices=JSON.parse(sessionStorage.getItem('officeList'));
  offices.forEach(oe => {
  this.OfficeIDList.push(oe.officeID)	
  if(oe.isMyoffice==true)
    this.myOfficeID=oe.officeID;
  });  
}

ngAfterContentChecked(){
  this.cdr.detectChanges();
}

ngOnInit(): void {
  var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules")); 
  var contName =[];
  contName = menuModulesList.filter(x => x.mainModuleName == 'Contact');
  if(contName.length>0){
    this.ContactName = contName[0].orgModuleName; 
  }  

  //this.mainModuleName="Forms";
  this.showAddButton=false; 
  this.showContactRoleAddButton=false;
  this.NormalContacts=[];
  this.SharedContacts=[];
  this.getSharedContactRoleList();
}

async getSharedContactRoleList(){
  var FormFolderId = Object.values(this.data)[1];
  var FormId = Object.values(this.data)[2];
  var typeId= Object.values(this.data)[3];
   // 1 for Folder , 2 for Form
  if(typeId ==1){
    FormFolderId = Object.values(this.data)[1];
  }
  if(typeId ==2){
    FormFolderId =Object.values(this.data)[2];
  }
  var ReqModel={
    nameFieldID:0,
    emailFieldID:0,
    databaseID:Number(this.databaseId),
    organizationID:Number(this.organizationId),   
    itemID:FormFolderId,
    itemType:typeId,
    pageIndex:0,
    pageSize:0,
    userID:this.currentUser.UID    
  }    
  const result = await this.formsService.GetAllFormSharedTo(ReqModel).toPromise();
  if (result.status === this.statusConst.statusSuccess) {    
    this.responseHolder = result.data.formSharedToList;
    if(this.responseHolder !=null){
      this.sharedList = this.responseHolder;
      this.sharedList.forEach(e => {
        e.shortName=e.name.match(/\b(\w)/g).join('');
        if(e.imageUrl==null){
          e.imageUrl="";
        }
        if(e.shareToType==4){          
          e.name = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.name);
          e.shortName = e.name.match(/\b(\w)/g).join('');
        }
      });      
    }          
  }
  else {
  } 
}

// getCloseDetail(message) {
//   this.showDetail = message;
// }

addNew(module){
  this.Module = module;
  this.showAddContact = true;//!this.showAddContact;
}

// getClose(message){
//   this.showAddContact = message;
// }

// addContact(){
//   this.addnewContact = !this.addnewContact;
// }

// addSharedContact(){
//   this.addnewSharedContact = !this.addnewSharedContact;
// }

// private _filterStates(value: string): State[] {
//   const filterValue = value.toLowerCase();
//   return this.states.filter(state => state.name.toLowerCase().indexOf(filterValue) === 0);
// }

// remove(fruit: string): void {
//   const index = this.selectedRoles.indexOf(fruit);
//   if (index >= 0) {
//     this.selectedRoles.splice(index, 1);
//   }
// }

// add(event: MatChipInputEvent): void {
//   const input = event.input;
//   const value = event.value.toLowerCase(); 
//   if ((value || '').trim()) {
//     var arrToUp = String.prototype.toLowerCase.apply(this.selectedRoles).split(",");
//     const index = arrToUp.indexOf(value.trim());
//     if (index >= 0) {
//       //this.fruits.splice(index, 1);
//     }
//     else {
//       this.selectedRoles.push(event.value.trim());
//     }
//   }
//   // Reset the input value
//   if (input) {
//     input.value = '';
//   }
//   this.roleCtrl.setValue(null);
// }

// selected(event: MatAutocompleteSelectedEvent): void {
//   const index = this.selectedRoles.indexOf(event.option.viewValue);
//   if (index >= 0) {
//     this.roleInput.nativeElement.value = '';  
//   }
//   else {
//     this.selectedRoles.push(event.option.viewValue);
//     this.roleInput.nativeElement.value = '';
//     this.roleCtrl.setValue(null);
//   }
// }

// private _filter(value: string): string[] {
//   const filterValue = value.toLowerCase();
//   return this.allTransRoles.filter(fruit => fruit.name.toLowerCase().indexOf(filterValue) === 0);
// }

getCloseDetails(message){
  this.showDetail = false;
}


// getNormalAndSharedContacts() {
//   this.contactsVm.DatabaseID = Number(this.databaseId);
//   this.contactsVm.OrganizationID = Number(this.organizationId);
//   this.contactsVm.UserID = this.currentUser.UID;
//   this.contactsVm.CompanyID=Number(sessionStorage.getItem("transactionID"));
//   this.loaderService.show();
//   this.contactsService.getNormalAndSharedCompanyContacts(this.contactsVm).subscribe(response => {
//     if (response != undefined) {
//       this.responseHolder = response;
//       if (this.responseHolder.status == this.statusConst.statusSuccess) {
//         this.NormalContacts = response.data.contactListModel;
//         this.SharedContacts = response.data.sharedContactListModel;
//         this.SharedRoleList = response.data.sharedRoleListModel;
//         this.NormalContacts.forEach(e => {
//           e.shortName=e.name.match(/\b(\w)/g).join('');
//         });
//         this.SharedContacts.forEach(e => {
//           e.shortName=e.name.match(/\b(\w)/g).join('');
//         });
//         this.SharedRoleList.forEach(e => {
//           e.shortName=e.name.match(/\b(\w)/g).join('');
//         });
//         this.loaderService.hide();
//       }
//     }
//     else{
//       this.loaderService.hide();
//     }
//   });
// }


getContactListCoreImplementation(searchValue:any) {
 this.filteredContactVm.DatabaseID = Number(this.databaseId);
 this.filteredContactVm.OrganizationID = Number(this.organizationId);
 this.filteredContactVm.UserID = this.currentUser.UID;
 this.filteredContactVm.searchValue=searchValue;
 this.searchName =searchValue;
 if(this.data.formFolderID>0)
 this.filteredContactVm.formFolderID=this.data.formFolderID;
 else
 this.filteredContactVm.formFolderID=0;
 if(this.data.formID>0)
 this.filteredContactVm.formID=this.data.formID;
 else
 this.filteredContactVm.formID=0;
 this.companyID=Number(sessionStorage.getItem("transactionID"));
 this.filteredContactVm.PageSize=0;
 this.contactsService.GetContactListCoreImplementation(this.filteredContactVm).subscribe(response => {
   if (response != undefined) {
     this.responseHolder = response;
     if (this.responseHolder.status == this.statusConst.statusSuccess) {
       this.contactsList = response.data.contactListModel;
       this.contactsList.forEach(e => {
        e.shortName=e.name.match(/\b(\w)/g).join('');
      });
      this.contactsList.push(
        {
          "contactID":0,
          "companyID":0,
          "name":"Create New",
          "email":"",
          "imageUrl":"",
          "isShared":this.isShare,
          "coreContactUserMapID":0,
          "trasactionalRoleIds":[],
          "contactCoreRoleMappingModels":[],
          "shortName":"CN"
        }
      )    
     }
   }
 });
}


// getTransactinalRoles(searchValue:any) {
//  this.filteredContactVm.DatabaseID = Number(this.databaseId);
//  this.filteredContactVm.OrganizationID = Number(this.organizationId);
//  this.filteredContactVm.UserID = this.currentUser.UID;
//  this.filteredContactVm.searchValue=searchValue;
//  this.filteredContactVm.PageSize=0;
//  this.contactsService.getTransactinalRoles(this.filteredContactVm).subscribe(response => {
//    if (response != undefined) {
//      this.responseHolder = response;
//       if (this.responseHolder.status == this.statusConst.statusSuccess) {
//        this.transRoleList = response.data.transactionalRolesModels;
//        this.transRoleList=this.transRoleList.filter(m=>!this.currentRoleContact.trasactionalRoleIds.includes(m.transctionalRoleID));
//        if(this.transRoleList.length==0)
//           this.transRoleList.push(
//            {
//              "transctionalRoleID":0,
//              "companyID":0,
//              "transactionalRoleName":searchValue,
//            }
//          )    
//      }
//    }
//  });
// }

// deleteSelectedContact(companyID:any,contactID:any,contactCompanyUserMapID:any){
//   this.contactsVm.DatabaseID = Number(this.databaseId);
//   this.contactsVm.OrganizationID = Number(this.organizationId);
//   this.contactsVm.UserID = this.currentUser.UID;
//   this.contactsVm.CompanyID=Number(sessionStorage.getItem("transactionID"));
//   this.contactsVm.ContactCompanyUserMapID = Number(contactCompanyUserMapID); 
//   this.contactsVm.ContactCompanyRoleID=0; 
//   this.contactsVm.ContactID=Number(contactID); 
//   this.loaderService.show();
//   this.contactsService.deleteSelectedCompanyContact(this.contactsVm).subscribe(response => {
//     if (response != undefined) {
//       this.responseHolder = response;
//       if (this.responseHolder.status == this.statusConst.statusSuccess) {
//         this.NormalContacts = response.data.contactListModel;
//         this.SharedContacts= response.data.sharedContactListModel;
//         this.SharedRoleList = response.data.sharedRoleListModel;
//         this.NormalContacts.forEach(e => {
//           e.shortName=e.name.match(/\b(\w)/g).join('');
//         });
//         this.SharedContacts.forEach(e => {
//           e.shortName=e.name.match(/\b(\w)/g).join('');
//         });
//         this.SharedRoleList.forEach(e => {
//           e.shortName=e.name.match(/\b(\w)/g).join('');
//         });
//         this.loaderService.hide();
//       }
//     }
//   });
// }

actionSelected(action,actionType,shareToID){
   this.peoples.find(m=>m.shareToID==shareToID).actionType=actionType;
}


actionRoleSelected(action,actionType,shareToID){
   this.selectedsharedAccessRole.find(m=>m.shareToID==shareToID).actionType=actionType;
}

getActionType(actionType){
  if(actionType==-1)
  return this.actionTypeArray= ["Remove"];
  if(actionType==0)
  return this.actionTypeArray= ["Viewer"];
  if(actionType==1)
  return this.actionTypeArray= ["Editor"]
}

contactSelected(contactSelected:any){
  if(contactSelected.contactID == 0) { 
  this.dialog.getDialogById("addContactOrRoleDialog").close();
  this._dataSharingService.SendCurrentFormContact(contactSelected.currentValue==''?'Create New':contactSelected.currentValue); 
  return ;
 }

 let contact= this.peoples.find(m=>m.shareToID == contactSelected.contactID);
 
 if(contact == undefined || contact=='' || contact == null){ 
  this.peoples.push({
    name : contactSelected.name,
    email: contactSelected.email,
    img: contactSelected.imageUrl, 
    shortName:contactSelected.shortName,
    shareToID: contactSelected.contactID,
    shareToType: 1,
    actionType: 0 
  });
  if(this.peoples.length > 0){
    this.showAddButton=true;
  }
  else{
    this.showAddButton=false;
  } 
 } 
}

// RoleSelected(roleSelected:any){
//   let role= this.Roles.find(m=>m.transctionalRoleID == roleSelected.transctionalRoleID);  
//   if(roleSelected.transctionalRoleID==0) { 
//   if(this.currentRoleContact.contactCompanyRoleMappingModels.find(m=>m.rloeName.toLowerCase()==roleSelected.transactionalRoleName.toLowerCase())!=undefined)
//   {
//     this.toastr.warning('Role already selected.', '', {
//       timeOut: 3000,
//     });
//     return;
//   }
//   let newRole = this.Roles.find(m=>m.transactionalRoleName.toLowerCase() == roleSelected.transactionalRoleName.toLowerCase());
//    if(newRole==undefined) { 
//      this.Roles.push({
//         transactionalRoleName : roleSelected.transactionalRoleName, 
//         transctionalRoleID:roleSelected.transctionalRoleID,
//         CompanyID:Number(sessionStorage.getItem("transactionID")),
//         ContactID:Number(this.currentRoleContact.contactID)
//       });
//       if(this.Roles.length > 0){
//         this.showAddButton =true;
//         //this.showContactRoleAddButton=true;
//       }
//       if(this.Roles.length == 0){
//         this.showAddButton =false;
//         //this.showContactRoleAddButton=false;
//       }
//     }
//     return;
//   }
  
//   if(role==undefined || role=='' || role==null) { 
//    this.Roles.push({
//     transactionalRoleName : roleSelected.transactionalRoleName, 
//      transctionalRoleID:roleSelected.transctionalRoleID,
//      CompanyID:Number(sessionStorage.getItem("transactionID")),
//      ContactID:Number(this.currentRoleContact.contactID)
//    });
//   } 

//   if(this.Roles.length > 0){
//     this.showContactRoleAddButton=true;
//   }
//   if(this.Roles.length == 0){
//     this.showContactRoleAddButton=false;
//   }
// }

// addUpdateCompanyContactRole(){
//   if(this.Roles.length > 0) {
//    // this.ContactRoleUpdate()
//  } 
// }


FormFolderContactRoleUpdate(){
  this.showAddButton=false;
  this.data;
  var typeId= Object.values(this.data)[3]; 
  var shareTo:any=[];

    if(this.selectedContact==true){
        shareTo=this.peoples;
      }

    if(this.selectedRole==true){
       shareTo=this.selectedsharedAccessRole;
     }
     if(this.selectedUser==true){
       shareTo=this.userSelectedList;
     }

  if(typeId ==1){
    //if(this.isSharedAccessRolePopup==true? this.selectedsharedAccessRole.length > 0:this.peoples.length > 0) { 
      this.spinner=true;
      let ReqModel ={
        shareTo : shareTo,
       //shareTo : this.isSharedAccessRolePopup==true? this.selectedsharedAccessRole:this.peoples,
       UserID : this.currentUser.UID,
       DatabaseID : Number(this.databaseId), 
       OrganizationID : Number(this.organizationId),
       id: this.data.formFolderID,
       officeID:this.myOfficeID    
       }
       if(this.data.formFolderID>0) {
       this.formsService.ShareFormFolder(ReqModel).subscribe(response => {
         if (response != undefined) {
           this.responseHolder = response;
           if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success('Folder shared successfully.', '', {
              timeOut: 3000,
            });
             this.spinner=false;
             this.loaderService.hide();
             this.dialog.closeAll();
             this.dialogRef.close('Added');
             this._dataSharingService.sendRefreshDetailsSharedRoleListForForm(true); 
           }
           else {
             this.spinner=false;
             this.loaderService.hide();
             this.dialog.closeAll();
           }
         }
       });
     //}    
    } else {
      this.spinner=false;
      this.loaderService.hide();
      this.dialog.closeAll();
    }
  }
  if(typeId ==2){
   // if(this.isSharedAccessRolePopup==true? this.selectedsharedAccessRole.length > 0:this.peoples.length > 0) { 
      this.spinner=true;
      let ReqModel ={
        shareTo : shareTo,
       //shareTo : this.isSharedAccessRolePopup==true? this.selectedsharedAccessRole:this.peoples,
       UserID : this.currentUser.UID,
       DatabaseID : Number(this.databaseId), 
       OrganizationID : Number(this.organizationId),
       id: this.data.formID,
       officeID:this.myOfficeID      
       }       
       this.formsService.ShareForm(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.toastr.success('Forms shared successfully.', '', {
                timeOut: 3000,
              });
            this.spinner=false;
            this.loaderService.hide();
            this.dialog.closeAll();
            this.dialogRef.close('Added');
            this._dataSharingService.sendRefreshDetailsSharedRoleListForForm(true); 
          }
          else {
            this.spinner=false;
            this.loaderService.hide();
            this.dialog.closeAll();
          }
        }else{
          this.spinner=false;
          this.loaderService.hide();
          this.dialog.closeAll();
        }
      });
    // }
     
  }  
}

// addUpdateCompanyContact(){
//   if(this.isSharedAccessRolePopup == false){
//     if(this.peoples.length > 0) { 
//       this.dialog.closeAll();
//       this.contactsVm.DatabaseID = Number(this.databaseId);
//       this.contactsVm.OrganizationID = Number(this.organizationId);
//       this.contactsVm.UserID = this.currentUser.UID;
//       this.contactsVm.AddUpdateCoreContactCompanyListModel = this.peoples;
//       this.loaderService.show();
//       this.contactsService.addUpdateCompanyContact(this.contactsVm).subscribe(response => {
//         if (response != undefined) {
//           this.responseHolder = response;
//           if (this.responseHolder.status == this.statusConst.statusSuccess) {
//             this.NormalContacts = response.data.contactListModel;
//             this.SharedContacts= response.data.sharedContactListModel;
//             this.NormalContacts.forEach(e => {
//               e.shortName=e.name.match(/\b(\w)/g).join('');
//             });
//             this.SharedContacts.forEach(e => {
//               e.shortName=e.name.match(/\b(\w)/g).join('');
//             });
//             this.peoples=[];          
//             this.showAddButton=false;
//             this.loaderService.hide();
//           }
//         }
//       });
//    }else{
//     this.dialog.closeAll();
//    }
//   }
//   if(this.isSharedAccessRolePopup == true){
//     if(this.selectedsharedAccessRole.length > 0) { 
//       this.dialog.closeAll();
//       this.contactsVm.DatabaseID = Number(this.databaseId);
//       this.contactsVm.OrganizationID = Number(this.organizationId);
//       this.contactsVm.UserID = this.currentUser.UID;
//       this.contactsVm.AddUpdateCoreContactCompanyListModel = this.selectedsharedAccessRole;
//       this.loaderService.show();
//       this.contactsService.addUpdateCompanyContact(this.contactsVm).subscribe(response => {
//         if (response != undefined) {
//           this.responseHolder = response;
//           if (this.responseHolder.status == this.statusConst.statusSuccess) {
//             this.NormalContacts = response.data.contactListModel;
//             this.SharedContacts= response.data.sharedContactListModel;
//             this.SharedRoleList = response.data.sharedRoleListModel;
//             this.NormalContacts.forEach(e => {
//               e.shortName=e.name.match(/\b(\w)/g).join('');
//             });
//             this.SharedContacts.forEach(e => {
//               e.shortName=e.name.match(/\b(\w)/g).join('');
//             });
//             this.SharedRoleList.forEach(e => {
//               e.shortName=e.name.match(/\b(\w)/g).join('');
//             });
//             this.peoples=[];
//             this.selectedsharedAccessRole=[];       
//             this.showAddButton=false;
//             this.loaderService.hide();
//           }
//         }
//       });
//    }else{
//     this.dialog.closeAll();
//    }
//   }
// }


removeRoles(item:any,isRolePopup:boolean){
  if(isRolePopup){
  const index = this.selectedsharedAccessRole.indexOf(item);
  if (index >= 0) {
    this.selectedsharedAccessRole.splice(index, 1);
   }
  }   
  if(this.selectedsharedAccessRole.length > 0){
    this.showAddButton=true;
  }
  if(this.selectedsharedAccessRole.length == 0){
    this.showAddButton=false;
  }
}

removeItemContact(item:any,isRolePopup:boolean){
  if(!isRolePopup){  
  const index = this.peoples.indexOf(item);
  if (index >= 0) {
    this.peoples.splice(index, 1);
  }
  }
  if(this.peoples.length == 0){
    this.showAddButton =false;
  }
  if(this.peoples.length > 0){
    this.showAddButton=true;
  }
  
}

// addShare(templateRef: TemplateRef<any>,isShare:boolean,isRole:boolean,contact:any) {
//   this.isShare=isShare;
//   this.isRolePopup=isRole;
//   this.isSharedAccessRolePopup=false;
//   this.companyID=Number(sessionStorage.getItem("transactionID"));
//   if(isRole)
//   this.currentRoleContact=contact;
//   this.transRoleList=[];
//   this.contactsList=[];  
//   this.Roles=[];
//   this.peoples=[];
//   this.selectedsharedAccessRole=[];
//   this.showContactRoleAddButton=false;
//   const dialogRef = this.dialog.open(templateRef,{
//     panelClass: 'custom-modalbox'
//   });
// }


close() {
  this.peoples=[];  
  this.Roles=[];
  this.selectedsharedAccessRole=[];
  this.showAddButton=false;
  this.dialog.closeAll();
}


// deleteRole(contactCompanyRoleID:any,e:any ){
//   e.currentTarget.parentElement.remove();
//   this.contactsVm.DatabaseID = Number(this.databaseId);
//   this.contactsVm.OrganizationID = Number(this.organizationId);
//   this.contactsVm.UserID = this.currentUser.UID;
//   this.contactsVm.ContactCompanyRoleID=Number(contactCompanyRoleID);
//   this.loaderService.show();
//   this.contactsService.deleteSelectedCompanyContact(this.contactsVm).subscribe(response => {
//     if (response != undefined) {
//       this.responseHolder = response;
//       if (this.responseHolder.status == this.statusConst.statusSuccess) {
//         this.toastr.success('Deleted successfully.', '', {
//           timeOut: 3000,
//         });
//         this.loaderService.hide();
//       }
//     }
//   });
// }


//== For Shared Access Role == //
showRoleMessage:boolean=false;

getSharedAccessRoles(searchValue:any) {
var ReqModel={
  DatabaseID : Number(this.databaseId),
  OrganizationID: Number(this.organizationId),
  UserID : this.currentUser.UID,
  formFolderID: this.data.formFolderID>0?this.data.formFolderID:0,
  formID: this.data.formID>0?this.data.formID:0,
  searchValue:searchValue
 }
 if(searchValue==""){
  this.showRoleMessage=false;
 }  
  this.contactsService.getSharedAccessRoles(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.formsService.GetAllFromFolderSharedRole(ReqModel).subscribe(response1 => {
          if (response1 != undefined) {
            if (response1.status == this.statusConst.statusSuccess) {
              this.sharedAccessRoleList = response.data;
              let roleIdListForFormOrFolder=response1.data;
              this.sharedAccessRoleList=this.sharedAccessRoleList.filter(m=>!roleIdListForFormOrFolder.includes(m.roleID))
              if(this.sharedAccessRoleList.length==0 && !this.showRoleMessage && searchValue!="") {
                this.showRoleMessage=true;
                this.toastr.info('No role left to assign, contact to administrator.', '', {
                timeOut: 3000,
              });
              }else{
                
              }
           }
         }
        });
      }
    }
  });
}

RoleSelectedForSharedAccess(roleSelected:any){
  let role= this.selectedsharedAccessRole.find(m=>m.shareToID == roleSelected.roleID); 
  if(roleSelected.roleID == 0) { 
  // if(this.currentRoleCompany.companyCoreRoleMappingModels.find(m=>m.rloeName.toLowerCase()==roleSelected.name.toLowerCase())!=undefined)
  // {
  //   this.toastr.warning('Role already selected.', '', {
  //     timeOut: 1000,
  //   });
  //   return;
  // }
   let newRole = this.selectedsharedAccessRole.find(m=>m.name.toLowerCase() == roleSelected.name.toLowerCase());
   if(newRole == undefined) { 
     this.selectedsharedAccessRole.push({      
        name : roleSelected.roleName,
        email: '',
        img: '', 
        isShared:this.isShare,
        shortName:'',
        shareToID: roleSelected.roleID,
        shareToType: 2,
        actionType: 0 
      });
      if(this.selectedsharedAccessRole.length > 0){
        this.showAddButton=true;
      }
      if(this.selectedsharedAccessRole.length == 0){
        this.showAddButton=false;
      }
    }
    return;
  }
  
  if(role == undefined || role == '' || role == null) { 
    this.selectedsharedAccessRole.push({      
      name : roleSelected.roleName,
      email: '',
      img: '', 
      isShared:this.isShare,
      shortName:'',
      shareToID: roleSelected.roleID,
      shareToType: 2,
      actionType: 0 
   });
  } 

  if(this.selectedsharedAccessRole.length > 0){
    this.showAddButton=true;
  }
  if(this.selectedsharedAccessRole.length == 0){
    this.showAddButton=false;
  }
}

// removeItemRoleSharedAccess(item:any,isSharedAccessRolePopup:boolean){
//   if(this.isSharedAccessRolePopup){
//     const index = this.selectedsharedAccessRole.indexOf(item);
//     if (index >= 0) {
//           this.selectedsharedAccessRole.splice(index, 1);
//         }      
//        if(this.selectedsharedAccessRole.length > 0){
//         this.showAddButton =true;
//       }
//         if(this.selectedsharedAccessRole.length == 0){
//           this.showAddButton =false;
//         }
//   }  
// }

isSharedAccessUserPopup:boolean=false;
userSelectedList:any=[]=[];
sharedAccessUserList: any=[];
timeout = null;
selectedContact:boolean=true;
selectedRole:boolean=false;
selectedUser:boolean=false;

selectSharedAccessRb(value){
  // Role
 if(value == 2){
   this.selectedContact=false;
   this.selectedRole=true;
   this.selectedUser=false;
   this.isSharedAccessRolePopup=true;
   this.peoples=[];
   this.selectedsharedAccessRole=[];
   this.showAddButton =false;
   this.isSharedAccessUserPopup=false;
   this.userSelectedList=[];
 }
 // Contact
 if(value == 1){
   this.selectedContact=true;
   this.selectedRole=false;
   this.selectedUser=false;
   this.isSharedAccessRolePopup=false;
   this.peoples=[];
   this.selectedsharedAccessRole=[];
   this.showAddButton =false;
   this.isSharedAccessUserPopup=false;
   this.userSelectedList=[];
 }
 // User
 if(value == 3){
   this.selectedContact=false;
   this.selectedRole=false;
   this.selectedUser=true;
   this.isSharedAccessRolePopup=false;
   this.isSharedAccessUserPopup=true;
   this.peoples=[];
   this.selectedsharedAccessRole=[];
   this.userSelectedList=[];
   this.showAddButton =false;
 }
 }


 searchUser(val) {
  if (val.length >= 2) {
    this.sharedAccessUserList = [];
    if (val != '') {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getUserListCoreImplementation(val)
      }, 500);
    } else {
      this.sharedAccessUserList = [];
    }
  }
}

getUserListCoreImplementation(searchValue: any) {
  if (searchValue == "" || searchValue == null || searchValue == undefined) {
    this.sharedAccessUserList = [];
    return;
  }
  var ReqModel = {
    DatabaseID: Number(this.databaseId),
    OrganizationID: Number(this.organizationId),
    officeID:this.myOfficeID,
    searchKey: searchValue.trim(),
    PageSize: 0,
    pageIndex: 0,
    UserID: this.currentUser.UID
  }
  this.contactsService.GetUserList(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.sharedAccessUserList = response.data.userModel;
        this.sharedAccessUserList.map((res) => {
          if (res.email != null) {
            res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
          }
          if (res.firstName != null) {
            res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
          }
          if (res.lastName != null) {
            res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
          }
          return res;
        });
        this.sharedAccessUserList = this.sharedAccessUserList;
      }
    }
  });
}

userSelected(userSelected: any) {
  var user=[];
  user = this.userSelectedList.filter(m => m.userID == userSelected.userID);
  if (user.length==0) {   
    var shortName = userSelected.firstName.match(/\b(\w)/g).join('');
    this.userSelectedList.push({
       name: userSelected.firstName + " " + userSelected.lastName,      
       email: userSelected.email,        
       userID: userSelected.userID,      
       img: "",
       shortName:shortName,
       sharedUserID:userSelected.uuid,
       shareToType:4,
       actionType: 0    
    });    
  }else{
    this.toastr.warning('User allready added.', '', {
      timeOut: 3000,
    });
  }
  if(this.userSelectedList.length > 0){
    this.showAddButton=true;
  }
  else{
    this.showAddButton=false;
  } 
}

removeUser(item: any) {
  const index = this.userSelectedList.indexOf(item);
  if (index >= 0) {
    this.userSelectedList.splice(index, 1);   
  }
  if(this.userSelectedList.length == 0){
    this.showAddButton =false;
  }
}

// selectSharedAccessRb(value){
// if(value == 2){
//   this.isSharedAccessRolePopup=true;
//   this.peoples=[];
//   this.selectedsharedAccessRole=[];
//   this.showAddButton =false;
// }
// else{
//   this.isSharedAccessRolePopup=false;
//   this.peoples=[];
//   this.selectedsharedAccessRole=[];
//   this.showAddButton =false;
// }
// }




states: State[] = [
  {
    name: 'Abbott',
    email: 'Abbott@gmail.com',
    role: 'agent',
    pic: '../../../../../assets/images/avatars/Abbott.jpg'
  },
  {
    name: 'Alice',
    email: 'alice.@gmail.com',
    role: 'agent',
    pic: '../../../../../assets/images/avatars/alice.jpg'
  },
  {
    name: 'Carl',
    email: 'carl@gmail.com',
    role: 'agent',
    pic: '../../../../../assets/images/avatars/carl.jpg'
  },
  {
    name: 'Jane',
    email: 'jane@gmail.com',
    role: 'agent',
    pic: '../../../../../assets/images/avatars/jane.jpg'
  },
  {
    name: 'Tillman',
    email: 'tillman.@gmail.com',
    role: 'agent',
    pic: '../../../../../assets/images/avatars/Tillman.jpg'
  },
  {
    name: 'Josefina',
    email: 'Josefina@gmail.com',
    role: 'agent',
    pic: '../../../../../assets/images/avatars/Josefina.jpg'
  },
  {
    name: 'Create New',
    email: ' ',
    role: ' ',
    pic: ' '
  },

];

}
